// import { Card, CardBody } from "reactstrap";

// const TopCards = (props) => {
//   return (
//     <Card>
//       <CardBody>
//         <div className="d-flex">
//           <div className={`circle-box lg-box d-inline-block ${props.bg}`}>
//             <i className={props.icon}></i>
//           </div>
//           <div className="ms-3">
//             <h3 className="mb-0 font-weight-bold">{props.earning}</h3>
//             <small className="text-muted">{props.subtitle}</small>
//           </div>
//         </div>
//       </CardBody>
//     </Card>
//   );
// };

// export default TopCards;



import { Card, CardBody } from "reactstrap";

const TopCards = ({ bg, icon, earning, subtitle, onClick }) => {
  return (
    <Card
      onClick={onClick}                        // ✅ attach click handler
      style={{ cursor: onClick ? "pointer" : "default" }} // ✅ show pointer
      className="shadow-sm"
    >
      <CardBody>
        <div className="d-flex align-items-center">
          <div className={`circle-box lg-box d-inline-block ${bg}`}>
            <i className={icon}></i>
          </div>
          <div className="ms-3">
            <h3 className="mb-0 fw-bold">{earning}</h3>
            <small className="text-muted">{subtitle}</small>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default TopCards;

